import React, {useState, useEffect} from 'react'
import FilterBatches from './FilterBatches'
import {Pagination} from 'antd'
import PackagedTable from './table/PackagedTable'
import {getBatchesPackaged, exportBatchesPackaged} from '../../../services/api/3dApi'
import {_convertObject} from "../../../helpers/convertObject"
import downloadFileFromData from '../../../helpers/downloadFileFromData'
import {NavLink} from 'react-router-dom'
import moment from 'moment'
import { getLocalData } from '../../../services/StorageServices'

const ListPackagedPage = (props) => {
    const [listBatches, setListBatches] = useState([])
    const [listUsers, setListUsers] = useState([])
    const [listProducts, setListProducts] = useState([])
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(50)
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [filters, setFilters] = useState({})

    const _handlePageChange = page => {
        setPage(page)
    }

    const _handleShowSizeChange = (current, size) => {
        setLimit(size)
        setPage(1)
    }

    const refreshListPackaged = async () => {
        setLoading(true)
        setError('')

        try {
            const payload = {
                ...filters,
                page: page || 1,
                limit: limit || 50,
            }

            if (!listUsers || !listUsers.length) {
                payload.fetchUsers = true
            }

            if (!listProducts || !listProducts.length) {
                payload.fetchProducts = true
            }

            const response = await getBatchesPackaged(payload)
            const {data, success, error} = Object.assign({}, response)

            if (!success) {
                return setError(error)
            }

            const {batches, users, products, total} = data
            setListBatches(batches)
            users && setListUsers(users)
            products && setListProducts(products)
            setTotal(total)
        } catch (error) {
            setError(error.message)
        }

        setLoading(false)
    }

    const _exportAllItemBatches = async () => {
        setLoading(true)
        setError('')

        try {
            const payload = {
                ...filters,
            }

            const {data} = await exportBatchesPackaged(payload)

            if (data) {
                downloadFileFromData(data, {filename: `batches-packaged-${moment().format('YYYY-MM-DD-HH-mm-ss')}.csv`})
            }

            setLoading(false)

        } catch (e) {
            setError(e.message)
            setLoading(false)
        }
    }

    const _handleChangeFilters = (theFilters) => {
        setFilters({...filters, ...theFilters})
    }

    useEffect(() => {
        console.log('refresh')
        refreshListPackaged().then(() => {
        })

    }, [page, limit, filters])

    const userRole = getLocalData('userRole')
    const {
        request_update,
        base_cost_management,
        permission_management,
        role_management,
        user_action_management,
        user_management,
    }= {...userRole}
    const adminRole = !!request_update && !! base_cost_management && !!permission_management && !!role_management && !!user_action_management && !!user_management

    return (
        <div className="ListPackagedPage">
            <div className="container-fluid min-vh-100">
                <div className="col-12 mx-auto bg-white shadow-sm py-3 px-0 px-3">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h3 className="m-0">Danh sách đóng gói</h3>
                        </div>
                        <div>
                            {adminRole &&
                                <button type="button" className="ant-btn ant-btn-primary mx-4"
                                        onClick={_exportAllItemBatches}><span>Export item</span></button>
                            }

                            <button type="button" className="ant-btn bg-white">
                                <NavLink exact to="/batches/packing" className="nav-link p-0">
                                    Đánh dấu đóng gói
                                </NavLink>
                            </button>
                        </div>
                    </div>

                    <div className="jumbotron px-3 pb-0 pt-3 mb-3">
                        <FilterBatches
                            loading={loading}
                            listUsers={listUsers}
                            listProducts={listProducts}
                            onChangeFilters={_handleChangeFilters}
                            filters={filters}
                        />
                    </div>

                    <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                        <div>
                            {error && (
                                <div className="text-danger mb-2">{error}</div>
                            )}
                        </div>
                        <Pagination current={page} total={total} pageSize={limit}
                                    showTotal={(sum, range) => sum > 0 &&
                                        <div>{`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} lô hàng`}</strong>
                                        </div>}
                                    onChange={_handlePageChange}
                                    className="text-right" showSizeChanger
                                    pageSizeOptions={['10', '20', '50', '100']}
                                    onShowSizeChange={_handleShowSizeChange}/>
                    </div>

                    <div className="LazeCuttingTable">
                        <PackagedTable
                            listBatches={listBatches}
                            loading={loading}
                            onChangeFilters={_handleChangeFilters}
                            adminRole={adminRole}
                        />
                    </div>

                    <Pagination
                        current={page} total={total} pageSize={limit}
                        onChange={_handlePageChange}
                        showQuickJumper
                        className="CustomPagination text-right" showSizeChanger
                        pageSizeOptions={['10', '20', '50', '100']}
                        onShowSizeChange={_handleShowSizeChange}
                    />
                </div>
            </div>
        </div>
    )
}

export default ListPackagedPage